import { AnyDocument, IncludeParams } from '../../../types';
import { ConstructPatch } from '../../types/ConstructPatch';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const updateDocument = async <
  DocumentType extends AnyDocument = AnyDocument,
  Payload = Record<string, unknown>,
>(
  constructPatch: ConstructPatch,
  documentParams: DocumentParams,
  documentId: DocumentType['id'],
  params: Partial<IncludeParams>,
  payload: Payload,
): Promise<NonPaginatedResponse<DocumentType> | undefined> =>
  constructPatch<NonPaginatedResponse<DocumentType>>(
    `${DOCUMENTS_BASE_PATH}/${documentId}`,
    {
      params,
      headers: buildHeadersFromDocumentParams(documentParams),
      data: payload,
    },
  );
